export default function Button({
  disabled = false,
  customClass,
  text,
  onClick,
}) {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`px-6 py-2 font-[poppins] text-sm font-medium rounded-[10px] cursor-pointer leading-[22px] tracking-[0%] ${customClass}`}
    >
      {text}
    </button>
  );
}
